import { gql } from '@apollo/client';

const ATTACH_DOCUMENT = {
  mutation: gql`
    mutation AttachDocument($input: AttachDocumentInput!) {
      attachDocument(input: $input) {
        entityType
        name
        format
        documentStatus
        uploadDate
        expirationDate
        path
      }
    }
  `,
  policies: {
    fetchPolicy: 'no-cache',
    errorPolicy: 'all',
  },
};

export default ATTACH_DOCUMENT;
